import { enableProfiling, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (!environment.production) {
  enableProfiling();
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZonelessChangeDetection(), provideBrowserGlobalErrorListeners(), ...appConfig.providers]
}).catch(err => console.error(err));
